import styled from 'styled-components';

export const FilterSetterWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-top: 250px;
`;
